// Comments and raw text elements are matched first so links inside them are left untouched
const LINK_TAG_OR_SKIPPED = /<!--[\s\S]*?-->|<(script|style|textarea|title)\b[\s\S]*?<\/\1\s*>|<a(?=[\s>/])(?:[^>"']|"[^"]*"|'[^']*')*>/gi;
const TAG_ATTRIBUTE = /(\s+)([^\s"'>/=]+)(\s*=\s*(?:"[^"]*"|'[^']*'|[^\s"'=<>`]+))?/g;

/**
 * Sets rel="nofollow" on every link without an HTML parser, so it runs the same during SSR and in the browser.
 * Matches cheerio's output: an existing rel is replaced in place, a missing one is appended.
 * @param html The HTML to rewrite
 * @returns The HTML with nofollow links
 */
export function nofollowLinks(html: string) {
    return html.replace(LINK_TAG_OR_SKIPPED, (match, rawTextTag?: string) => {
        if (rawTextTag || match.startsWith("<!--")) return match;

        let hasRel = false;
        const tag = match.replace(TAG_ATTRIBUTE, (attribute, space: string, name: string) => {
            if (name.toLowerCase() !== "rel") return attribute;
            hasRel = true;
            return `${space}${name}="nofollow"`;
        });

        return hasRel ? tag : tag.replace(/\s*(\/?)>$/, ' rel="nofollow"$1>');
    });
}
